import React, { Component } from 'react';
import Truncate from 'react-truncate';
import { EventCardHeader } from './cards';
import Button from '../../../components/button/button';
import { MEDIA_TYPE_IS_VIDEO, MEDIA_TYPE_IS_CALLBACK, MEDIA_TYPE_IS_ARTICLE } from '../../../app-constants';
import { omnitureTriggerComponentAction } from '../../../utilities/omniture-data-layer';

class Article extends Component {
  handleClick = () => {
    const { clickAction } = this.props;
    if (clickAction) {
      clickAction({ data: { mediaType: this.props.mediaType, contentId: this.props.id, userId: this.props.uId } });
    }
    omnitureTriggerComponentAction(this.props);
  };

  render() {
    return (
      <React.Fragment>
        {/* some content needs the spacing for meta even if there is no supplied meta content */}
        {Object.prototype.hasOwnProperty.call(this.props, 'meta') && <EventCardHeader text={this.props.meta || ' '} />}
        {this.props.imageUrl &&
        <div className="image-wrapper"><img
          src={this.props.imageUrl}
          className="img-fluid"
          alt={this.props.imageAltText || this.props.title}
        /></div>}
        {(this.props.mediaType === MEDIA_TYPE_IS_VIDEO) &&
        <div
          className="youtube-thumbnail image-wrapper"
          onClick={this.handleClick}
          role="button"
          tabIndex="0"
          id={`ytv_${this.props.id}`}
        >
          <img
            src={`https://img.youtube.com/vi/${this.props.id}/mqdefault.jpg`}
            className="img-fluid"
            alt=""
          />
          <div className="td-icon icon-ui-video-play" />
        </div>
        }
        {this.props.icon && <div className={`td-icon ${this.props.icon}`} />}
        {this.props.title && <h4>{this.props.title}</h4>}
        {this.props.summary && this.props.truncateSummary && <p>
          <Truncate lines={3} ellipsis="..." className="text-truncate">
            {this.props.summary}
          </Truncate>
        </p>}
        {this.props.summary && !this.props.truncateSummary && <p>{this.props.summary}</p>}
        {this.props.url && (<a href={this.props.url} target="_blank" rel="noopener noreferrer" className="mt-auto">
          <Button
            className={`button clear ${this.props.mediaType === MEDIA_TYPE_IS_ARTICLE ? 'left-aligned' : ''}`}
            buttonText={this.props.buttonText}
            onClick={this.handleClick}
          />
        </a>)
        }
        {((this.props.mediaType === MEDIA_TYPE_IS_VIDEO && this.props.isTrendingArticle) || this.props.mediaType === MEDIA_TYPE_IS_CALLBACK)
        && <div className="bypassBug_IE__mr-auto mt-auto">
          <Button
            onClick={this.handleClick}
            className={`button clear ${this.props.mediaType === MEDIA_TYPE_IS_CALLBACK ? '' : 'left-aligned'}`}
            buttonText={this.props.buttonText}
            id={this.props.mediaType === MEDIA_TYPE_IS_VIDEO ? `ytv_${this.props.id}` : this.props.id}
          />
        </div>}
        {this.props.highlightsCarouselSlides && this.props.highlightsCarouselSlides.map(slide => slide)}
      </React.Fragment>
    );
  }
}

export default Article;
